import { render, staticRenderFns } from "./Geocercas.vue?vue&type=template&id=0d26c89e&scoped=true"
import script from "./Geocercas.vue?vue&type=script&setup=true&lang=js"
export * from "./Geocercas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Geocercas.vue?vue&type=style&index=0&id=0d26c89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d26c89e",
  null
  
)

export default component.exports